import { FC, ReactNode } from 'react';
import cn from 'classnames';
import { Radio } from 'dibs-elements/exports/Radio';
import dibsCss from 'dibs-css';

import styles from './styles/PaymentMethodSelectOption.scss';

type Props = {
    isChecked: boolean;
    dataTn: string;
    name: string;
    onChange: () => void;
    value: string;
    label: ReactNode;
    icon?: ReactNode;
    content?: ReactNode;
};

export const PaymentMethodSelectOption: FC<Props> = props => {
    const { isChecked, dataTn, onChange, name, value, icon, label, content } = props;

    const radioClass = cn(styles.radio, {
        [styles.checked]: isChecked,
    });

    return (
        <li
            className={cn(
                dibsCss.pSmall,
                dibsCss.border,
                dibsCss.borderDolphin,
                dibsCss.borderB0,
                dibsCss.borderSolid
            )}
        >
            <Radio
                checked={isChecked}
                dataTn={dataTn}
                name={name}
                onChange={onChange}
                value={value}
                label={
                    <div className={cn(dibsCss.flex, dibsCss.textSatan, dibsCss.itemsCenter)}>
                        {icon && <div className={cn(styles.icon, dibsCss.mrMedium)}>{icon}</div>}
                        {label}
                    </div>
                }
                wrapperClass={styles.customRadio}
                radioClass={radioClass}
                labelClass={styles.label}
            />
            {content}
        </li>
    );
};
